<template>
  <b-modal
      :ref="name"
      :title="title"
      :cancel-title="$t('btn.cancel')"
      ok-only
      size="md"
      @close="close"
      @ok="close"
  >
    <template #modal-header>
      <div class="w-100">
        <h4 class="float-left">{{ $t('modal.title.add_new_entry') }}</h4>
      </div>
    </template>
    <b-form>

      <b-form-group id="input-group-1" :label="$t('form.label.enter_key')" label-for="input-1">
        <b-form-input
            id="input-1"
            v-model="form.key"
            :state="validateState('key')"
            :placeholder="$t('form.placeholder.enter_key')"
            @change="$v.form.key.$touch"
            @keypress="isRestricted($event)"
            trim
            required
        ></b-form-input>
        <p v-if="$v.form.key.$dirty && !$v.form.key.required" class="text-danger">{{ $t('error.required') }}</p>
        <p v-if="$v.form.key.$dirty && !$v.form.key.allowedValuesByRegex" class="text-danger">{{ $t('error.allowed_values_by_regex') }}</p>
      </b-form-group>

      <b-form-group id="input-group-2" :label="$t('form.label.enter_label')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.label"
            :state="validateState('label')"
            :placeholder="$t('form.placeholder.enter_label')"
            @change="$v.form.label.$touch"
            required
        ></b-form-input>
        <p v-if="$v.form.label.$dirty && !$v.form.label.required" class="text-danger">{{ $t('error.required') }}</p>
      </b-form-group>

      <b-form-group id="input-group-3" :label="$t('form.label.enter_order')" label-for="input-3">
        <b-form-input
            id="input-3"
            type="number"
            v-model="form.entryOrder"
            :placeholder="$t('form.placeholder.enter_order')"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-checkbox
          id="checkbox-1"
          v-model="form.isActive"
          name="checkbox-1"
          :value="true"
          unchecked-value="not_accepted"
      >
        {{ $t('checkbox.is_active') }}
      </b-form-checkbox>

    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" class="mr-2" @click="close">{{ $t('btn.cancel') }}</b-button>
          <b-button variant="primary"  :disabled="busy" @click="submit">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>

</template>

<script>

import axios from "axios";
import {required} from "vuelidate/lib/validators";
import customValidators from "../../../validators/customValidators";

export default {
  props: {},
  data() {
    return {
      name: 'default-modal',
      title: '',
      busy: false,
      form: {
        label: '',
        key: '',
        dictionaryAlias: this.$route.params.entry,
        entryOrder: 0,
        isActive: true
      },
    }
  },
  validations: {
    form: {
      label: {
        required
      },
      key: {
        required,
        allowedValuesByRegex: customValidators.allowedValuesByRegex()
      }
    }
  },
  mounted: function () {
    this.$refs[this.name].show();
  },
  methods: {
    validateState(entry) {
      entry = this.$v.form[entry];

      const {$dirty, $error} = entry;
      return $dirty ? !$error : null;
    },
    isRestricted: function (e) {
      e = (e) ? e : window.event;
      let charCode = (e.which) ? e.which : e.keyCode;
      // Space not allowed
      if (charCode === 32) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    close() {
      this.$refs[this.name].hide();
    },
    submit() {
      if(!this.$v.$invalid) {
        this.busy = true;
        axios.post('/api/dictionary/entry', {...this.form, entryOrder: parseInt(this.form.entryOrder)}).then(
            () => {
              this.busy = false;
              this.close();
              this.$parent.$emit('refresh-dict');
            }
        ).catch(error => {
          console.log(error.request);
          console.log(error.response);
        })
      } else {
        this.$v.$touch();
      }
    }
  }

}

</script>
